import {I_ACCESS_TOKEN_PARAMS,I_COMMON_DELETE_PARAMS,_customFetch, getFetchDELETEOptions, getFetchGETOptions} from './_base';
import LoggerService,{formatTrace} from '../../LoggerService';
import APP_CONFIG from 'config';

// ---------------------------------
// --- ACTIVITY TYPES
// ---------------------------------

const ENDPOINT_ACTIVITY_TYPES = '/activity_types';

const logger = LoggerService.getInstance();

/**
 * Requete le endpoint activity-types
 * Récupère la liste des types d'activite
 * @param param0
 */
const get = async ({accessToken}:I_ACCESS_TOKEN_PARAMS):Promise<Response> => {
  logger.trace(...formatTrace('ApiEndpoints - activity_types - get...'));
  const options = getFetchGETOptions({accessToken});
  const URL = ENDPOINT_ACTIVITY_TYPES + APP_CONFIG.ENDPOINT_SUFFIX;
  return _customFetch(URL,options);
};

interface I_ACTIVITY_TYPE_POST_PARAMS {
  accessToken: string,
  name: string,
  description: string,
  import_rule?: string,
  parent: number,
}
/**
 * Requete le endpoint activity-types POST
 * Ajoute un type d'activite
 * @param param0
 * @returns
 */
const post = async ({accessToken,name,description,parent, import_rule}:I_ACTIVITY_TYPE_POST_PARAMS):Promise<Response> => {
  logger.trace(...formatTrace('ApiEndpoints - activity_types - post...'));
  const params = {
    method: 'POST',
    headers: {
      'X-API-KEY': APP_CONFIG.API_KEY,
      'Content-Type': 'application/json',
      'Authorization': 'Bearer '+accessToken
    },
    body: JSON.stringify({
      name: encodeURIComponent(name.trim()),
      description: encodeURIComponent(description.trim()),
      parent_id: parent > 0 ? parent : undefined,
      import_rule: import_rule ? encodeURIComponent(import_rule) : undefined
    })
  };
  const URL = ENDPOINT_ACTIVITY_TYPES + APP_CONFIG.ENDPOINT_SUFFIX;
  return _customFetch(URL,params);
};

/**
 * Requete le endpoint activity-types DELETE
 * Supprime un type d'activite
 * NB : j'ai mis un _ pcq delete est un mot clé interdit
 * @param param0
 * @returns
 */
const remove = async ({accessToken,id}:I_COMMON_DELETE_PARAMS):Promise<Response> => {
  logger.trace(...formatTrace('ApiEndpoints - activity_types - remove...'));
  const options = getFetchDELETEOptions({accessToken});
  const URL = `${ENDPOINT_ACTIVITY_TYPES}/${id}${APP_CONFIG.ENDPOINT_SUFFIX}`;
  return _customFetch(URL,options);
};

interface I_ACTIVITY_TYPE_PUT_PARAMS {
  accessToken: string,
  id: number,
  name: string,
  description: string,
  parent: number,
}
/**
 * Requete le endpoint activity-types PUT
 * Met à jour un type d'activite
 * @param param0
 * @returns
 */
const put = async ({accessToken,id,name,description,parent}:I_ACTIVITY_TYPE_PUT_PARAMS):Promise<Response> => {
  logger.trace(...formatTrace('ApiEndpoints - activity_types - put...'));
  const params = {
    method: 'PUT',
    headers: {
      'X-API-KEY': APP_CONFIG.API_KEY,
      'Content-Type': 'application/json',
      'Authorization': 'Bearer '+accessToken
    },
    body: JSON.stringify({
      name: encodeURIComponent(name.trim()),
      description: encodeURIComponent(description.trim()),
      parent_id: parent > 0 ? parent : undefined
    })
  };
  const URL = `${ENDPOINT_ACTIVITY_TYPES}/${id}${APP_CONFIG.ENDPOINT_SUFFIX}`;
  return _customFetch(URL,params);
};

const activityTypesEndpoints = {
  get,
  post,
  remove,
  put,
};

export default activityTypesEndpoints;
